import theme from '../../themes/theme';

const { appColors } = theme;
const flexDefaultProps = () => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignSelf: 'stretch',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
});

const infoTextStyles = () => ({
  height: '3em',
  color: appColors.regularText,
  fontFamily: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
  fontSize: '1.25em',
  fontWeight: 600,
  textAlign: 'center',
});

const panelStyles = () => ({
  flex: 1,
  flexDirection: 'column',
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  borderRight: `0.001em solid ${appColors.bgSolidColor}`,
  marginTop: '4em'
});

export default {
  container: {
    ...flexDefaultProps(),
    flex: 1,
    width: '100%',
    color: appColors.regularText,
  },
  dayPanel: {
    ...flexDefaultProps(),
    ...panelStyles(),
  },
  lastPanel: {
    ...panelStyles(),
    borderRight: '0',
  },
  panelContents: {
    ...flexDefaultProps(),
    flex: 1,
    alignSelf: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
  },
  panelSection: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignSelf: 'center',
  },
  weatherIcon: {
    marginTop: '0.75em',
    height: '3em',
    alignItems: 'flex-start',
  },
  additionalInfo: {
    ...infoTextStyles(),
    height: '1.625em',
  },
  panelTitleText: {
    color: appColors.primaryWhite,
    height: '2.125em',
    fontSize: '1.5em',
    fontFamily: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
    fontWeight: '600',
    letterSpacing: '-0.03125em',
    textAlign: 'center',
  },
  tempHigh: {
    color: appColors.primaryWhite,
    fontFamily: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
    fontSize: '2.125em',
    fontWeight: '600',
    letterSpacing: '-0.03125em',
    marginTop: '0.8125em'
  },
  precipText: {
    ...infoTextStyles(),
    height: '1.625em',
    color: appColors.primaryWhite,
    fontSize: '1.125em',
    fontWeight: 'normal',
    marginTop: '1.25em'
  },
  weatherInfoText: {
    ...infoTextStyles(),
    height: '1.625em',
    color: appColors.primaryWhite,
    fontSize: '1.125em',
    fontWeight: 'normal',
    textAlign: 'center',
    margin: '0 auto',
  },
};
